export const clamp = (text: string, maxLength: number) => {
  if (text.length > maxLength) {
    const left = text.slice(0, Math.floor(maxLength / 2));
    const right = text.slice(-Math.ceil(maxLength / 2), text.length);
    return `${left}...${right}`;
  }

  return text;
};
